import Cookies from 'js-cookie';

export const isCookieEnabled = (name: string) => {
    const value = Cookies.get(name);

    return value !== null && value !== undefined && value !== '' && value !== 'false';
};
